<template>
	<Modal v-model="modalShow"
           @on-ok="handleSubmit"
           :title="$t('components_sync_data_shop_index_25')">
      <el-select
style="width: 100%;"
:value="selectShops"
multiple
filterable
remote
:placeholder="$t('components_sync_data_shop_index_26')"
:remote-method="remoteMethod"
@change="onChange"
          >
          <el-option
            v-for="i in masterShops"
            :value="i.id"
            :key="i.id"
            :label="i.name"
          >
          </el-option>
        </el-select>
    </Modal>
</template>

<script>
import i18n from '../../locales/index'

import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'SyncDataShop',
  components: {},
  data () {
    return {
      selectShops: [],
      searchValue: '',
	    modalShow: false
    }
  },
  computed: {
    ...mapGetters('shop', ['shops', 'masterShops',  'meta', 'loading']),
  },
  created () {
    this.master_index({
          page: 1,
          per: 999,
        })
  },
  methods: {
    ...mapActions('shop', [
      'master_index',
      'changeQuery'
    ]),
    ...mapMutations('shop', ['changeQuery']),

    remoteMethod (query) {
      if (query !== '') {
        this.searchValue = query
        this.changeQuery({ 'q[name_eq]': this.searchValue })
        //  parent_shop_id_eq : ''
        this.master_index({
          page: 1,
          per: 999,
        })
      }
    },
    onChange (value) {
	  this.selectShops = value;
    },
	handleSubmit () {
	  console.log('this.selectShops', this.selectShops);
      this.$emit('sync', this.selectShops)
    },
	show() {
	  this.modalShow = !this.modalShow
	}
  }
}
</script>

<style lang='scss' scoped>
</style>
